<template>
  <div class="row">
    <div v-for="closeout in closeouts" class="col-12 mb-3">
      <div v-if="closeout.purchase">
        <span class="font-weight-bold">Trade #:</span>
        <a
          :href="`/admin/businesses/${closeout.purchase.business_id}/purchases/${closeout.purchase.id}/edit`"
          >{{ closeout.purchase.ref_id }}</a
        >
      </div>
      <div v-if="closeout.child_purchase">
        <span class="font-weight-bold"
          >{{ closeout.invoice_type.name }} Trade #:</span
        >
        <a
          :href="`/admin/businesses/${closeout.child_purchase.business_id}/purchases/${closeout.child_purchase.id}/edit`"
          >{{ closeout.child_purchase.ref_id }}</a
        >
      </div>
      <div v-if="closeout.sale">
        <span class="font-weight-bold"
          >{{ closeout.invoice_type.name }} Sale #:</span
        >
        <a
          :href="`/admin/businesses/${closeout.sale.business_id}/sales/${closeout.sale.id}/edit`"
          >{{ closeout.sale.ref_id }}</a
        >
      </div>
      <div v-if="closeout.off_pic_sale">
        <span class="font-weight-bold">Off PIC Sale:</span>
        <a
          :href="`/admin/businesses/${closeout.off_pic_sale.business_id}/sales/${closeout.off_pic_sale.id}/edit`"
          >{{ closeout.off_pic_sale.ref_id }}</a
        >
      </div>
    </div>
    <div class="col-12 text-right">
      <el-button class="btn-secondary" @click="$emit('close')">Close</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    closeouts: {
      type: [Array, Object],
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
